export const addThemeOverrides = (theme, overrides) => (
    Object.assign(theme.overrides, {
        App: overrides,
    })
);